import { z } from 'zod';
/**
 * 配額值類型
 * 可以是數字（表示限制數量）或布林值（表示是否啟用）
 */
const QuotaValueSchema = z.union([
    z.number().int().min(0).describe('配額數量（0 表示無限制）'),
    z.boolean().describe('是否啟用（true/false）'),
]);
/**
 * 配額覆蓋 Schema
 * 用於 tenants.quotaOverrides，允許覆蓋 SaaS 方案的預設配額
 * 例如：{ "products": 1000, "orders": 5000, "storage_mb": 10000 }
 */
export const QuotaOverridesSchema = z
    .record(z.string(), QuotaValueSchema)
    .nullable()
    .optional()
    .describe('配額覆蓋設定（JSONB 格式）');
/**
 * SaaS 方案配額 Schema
 * 用於 saas_plans.quotas，定義方案的預設配額
 * 例如：{ "products": 100, "orders": 1000, "storage_mb": 1000, "api_calls_per_month": 10000 }
 */
export const SaaSPlanQuotasSchema = z
    .record(z.string(), QuotaValueSchema)
    .default({})
    .describe('SaaS 方案配額設定（JSONB 格式）');
